import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { DestroyRef, inject } from '@angular/core';
import { IFilter, INotification } from '../core/interfaces';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationsApiService } from '../services/api/notificationsApi/notifications-api.service';
import { AuthStore } from './auth.store';

type INotificationsState = {
  notifications: INotification[];
  count: number,
  isLoading: boolean;
  isClearing: boolean;
};

const initialState: INotificationsState = {
  notifications: [],
  count: 0,
  isLoading: false,
  isClearing: false,
};

export const NotificationsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => {
    const api = inject(NotificationsApiService);
    const authStore = inject(AuthStore);
    return {
      getFilteredNotifications(filter: IFilter, ref: DestroyRef) {
        patchState(store, state => ({ ...state, isLoading: true }))
        api.getFilteredNotifications(filter).pipe(takeUntilDestroyed(ref)).subscribe({
          next: (res) => {
            patchState(store, state => ({
              notifications: [...state.notifications, ...res.data.list],
              count: res.data.totalRecords
            }))
          },
          complete: () => patchState(store, state => ({ ...state, isLoading: false })),
          error: () => patchState(store, state => ({ ...state, isLoading: false })),
        });
      },
      markNotificationAsRead(id: string, ref: DestroyRef) {
        api.markNotificationAsRead(id).pipe(takeUntilDestroyed(ref)).subscribe({
          next: (res) => {
            const LIST: INotification[] = JSON.parse(JSON.stringify(store.notifications()));
            const INDEX = LIST.findIndex((item) => item.id == id);
            LIST[INDEX].read_at = new Date().toDateString();
            patchState(store, { notifications: LIST });
            authStore.subtractUserNotificationsCount()
          },
        });
      },
      markAllNotificationsAsRead(ref: DestroyRef) {
        patchState(store, { isClearing: true });
        api.markAllNotificationsAsRead().pipe(takeUntilDestroyed(ref)).subscribe({
          next: () => {
            patchState(store, { notifications: [], count: 0 });
            authStore.clearUserNotificationsCount();
          },
          complete: () => patchState(store, { isClearing: false }),
          error: () => patchState(store, { isClearing: false }),
        });
      },
      pushNewNotification(item: INotification) {
        if (store.notifications().some(notification => notification.id === item.id)) {
          return;
        }

        authStore.updateUserNotificationsCount();
        patchState(store, state => ({
          notifications: [
            item,
            ...state.notifications
          ]
        }))
      },
      resetStore() {
        patchState(store, initialState)
      }
    }
  })
);
